export default {
      id: "ic-soc-snapchat-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-snapchat-usage",
      toString: function () {
        return this.url;
      }
    }